import { closeAside } from '@newStore/documentUI/documentUIState';
import { Component } from 'react';
import { connect } from 'react-redux';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
  dispatch: any;
}

class AsideErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  close = () => {
    const { dispatch } = this.props;
    dispatch(closeAside());
  };

  componentDidCatch() {}

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <>
        <div
          className="modal ng-aside horizontal right fade in ng-scope ng-isolate-scope"
          style={{ zIndex: 1050, display: 'block' }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-lg modal-aside">
                <div className="modal-content hide-box-shadow">
                  <div className="modal-header">
                    <div className="navbar-controls-left">
                      <div className="navbar-controls">
                        <div className="btn-toolbar">
                          <a className="btn btn-icon btn-default" onClick={this.close}>
                            <span className="glyphicon glyphicon-arrow-left" />
                            <span className="sr-only">Terug</span>
                          </a>
                          <div
                            className="navbar-text navbar-text-big navbar-text-special-margin"
                            style={{
                              whiteSpace: 'nowrap',
                              fontSize: '18px',
                              marginBottom: 0,
                              color: '#2c2c2c',
                              fontWeight: 700,
                            }}
                          >
                            Fout
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-body aside-components">
                    <div className="row">
                      <div className="c-404">
                        <i className="glyphicon glyphicon-warning" />
                        <p>Er is een fout opgetreden bij het openen van deze node.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal-backdrop fade ng-scope in"
          data-bootstrap-modal-aria-hidden-count="1"
          aria-hidden="true"
          style={{ zIndex: 1040 }}
        />
      </>
    );
  }
}

export default connect()(AsideErrorBoundary);
